export const borders = {
  radius: {
    sm: 5,
    md: 10,
    lg: 20,
  },
}
